import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { BookingCalendar } from "./components/BookingCalendar.tsx";
import { BookingForm } from "./components/BookingForm.tsx";
import {
  initDatabase,
  createReservation,
  getReservations,
} from "./services/database.ts";
import { Reservation, BookingFormData } from "./types/types";
import "./App.css";
import { AdminPanel } from "./components/AdminPanel.tsx";
import { SuccessPage } from "./components/SuccessPage.tsx";

const App: React.FC = () => {
  const [reservations, setReservations] = useState<Reservation[]>([]);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);

  useEffect(() => {
    initDatabase();
    loadReservations();
  }, []);

  const loadReservations = async () => {
    try {
      const existingReservations = await getReservations();
      setReservations(existingReservations);
    } catch (error) {
      console.error("Error loading reservations:", error);
      // Можете да добавите състояние за показване на грешката на потребителя
    }
  };

  const handleDateSelection = (
    startDate: Date | null,
    endDate: Date | null
  ) => {
    setSelectedStartDate(startDate);
    setSelectedEndDate(endDate);
  };

  const handleBookingSubmit = async (formData: BookingFormData) => {
    if (!selectedStartDate || !selectedEndDate) return;

    try {
      console.log("Submitting booking with dates:", {
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        ...formData,
      });

      await createReservation({
        startDate: selectedStartDate.toISOString(),
        endDate: selectedEndDate.toISOString(),
        ...formData,
      });

      // При успех пренасочваме към success страницата
      window.location.href = "/success";
    } catch (error: any) {
      console.error("Booking error:", error);
      alert(
        error.message || "Възникна грешка при създаването на резервацията!"
      );
    }
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="app">
                <header className="header">
                  <h3>
                    <a href="https://nameren-rai.com" className="logo-href">
                      NAMEREN-RAI.COM
                    </a>
                  </h3>
                  <h4>Резервация на бунгало</h4>
                </header>

                <main className="booking-container">
                  <h3 className="book-title">
                    Изберете дати и направете вашата резервация
                  </h3>
                  <BookingCalendar
                    existingReservations={reservations}
                    onDateSelection={handleDateSelection}
                  />
                  {selectedStartDate && selectedEndDate && (
                    <BookingForm
                      onSubmit={handleBookingSubmit}
                      startDate={selectedStartDate}
                      endDate={selectedEndDate}
                    />
                  )}
                </main>
              </div>
              <footer className="footer">
                <p>© 2025 NAMEREN-RAI.COM. Всички права запазени.</p>
              </footer>
            </>
          }
        />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </Router>
  );
};

export default App;
